import styled, { keyframes } from "styled-components";
import { tokens } from "@swiggy-private/dls-web-common/dist/components/tokens";

const gradientShimmer = keyframes`
    0% {
        background-position: -1000px 0;
    }

    100% {
        background-position: 1000px 0;
    }
`;

const ShimmerDiv = styled.div`
    background: linear-gradient(
        90deg,
        ${tokens.colors.slateAlpha15} 0%,
        ${tokens.colors.slateAlpha05} 52.08%,
        ${tokens.colors.slateAlpha15} 100%
    );
    background-size: 1000px 100%;
    animation: ${gradientShimmer} 3s infinite linear;
`;

export const ShimmerWrapper = styled.div(({ theme }) => ({
    margin: `${theme.spacing.medium} ${theme.spacing.medium} 0`,
}));

export const ShimmerContainer = styled.div`
    padding-top: ${props => props.theme.spacing.xSmall};
    padding-bottom: ${props => props.theme.spacing.xxSmall};
    background: ${props => props.theme.colors.light.background_Primary};
    border-radius: ${props => props.theme.spacing.medium};
`;

export const ShimmerRow = styled.div`
    display: flex;
    align-items: center;
    border-radius: 1000px;
    padding: ${props => props.theme.spacing.xxSmall};
    margin: 0 ${props => props.theme.spacing.xSmall};
    gap: ${props => props.theme.spacing.xSmall};
`;

export const ShimmerColumn = styled.div`
    position: relative;
    padding: ${props => props.theme.spacing.medium} ${props => props.theme.spacing.medium}
        ${props => props.theme.spacing.medium} ${props => props.theme.spacing.large};
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const ShimmerTextWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: ${props => props.theme.spacing.small};
`;

export const ShimmerTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${props => props.theme.spacing.xxSmall};
`;

export const TextPlaceholder = styled(ShimmerDiv)<{ width?: number; height?: number; cornerRadius?: number }>`
    width: ${props => (props.width ? `${props.width}px` : "100%")};
    height: ${props => props.height}px;
    border-radius: ${props => (props.cornerRadius ? `${props.cornerRadius}px` : props.theme.spacing.small)};
`;
